import { faPhoneFlip, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Chip, Typography } from '@material-ui/core';
import { FunctionComponent, useMemo } from 'react';
import { useCommonStyles } from 'components/UI/CommonStyles';
import { useClientInfoStyles } from 'components/Payments/SingleSale/ClientInfo/ClientInfo.styles';
import clsx from 'clsx';
import Client from '@spike/client-model';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { ClientProfileOverview } from '@spike/client-model';

interface ClientInfoProps {
    data: Client;
}

export const ClientInfo: FunctionComponent<ClientInfoProps> = props => {
    const classes = useClientInfoStyles();
    const commonClasses = useCommonStyles();
    const profileOverview = useSelector<RootState, ClientProfileOverview | undefined>(
        state => state.clients.profileOverview
    );

    const parseMoney = (value: unknown): number => {
        if (typeof value === 'number') return value;
        if (typeof value !== 'string') return Number.NaN;
        return parseFloat(value.replace(/[^0-9.-]+/g, ''));
    };

    const getProfileCustomerId = (overview: ClientProfileOverview | undefined): number | undefined => {
        const anyOverview = overview as any;
        return (
            anyOverview?.customer?.id ??
            anyOverview?.customerId ??
            anyOverview?.customer?.customerId ??
            anyOverview?.customer?.clientId
        );
    };

    const clientOwes = useMemo(() => {
        if (!props.data?.id || !profileOverview) return false;

        const overviewCustomerId = getProfileCustomerId(profileOverview);
        if (overviewCustomerId != null && overviewCustomerId !== props.data.id) return false;

        const debt = (profileOverview as any)?.outstandingInvoices?.invoiceDebt;
        const amount = parseMoney(debt);
        return !Number.isNaN(amount) && amount > 0;
    }, [props.data?.id, profileOverview]);

    return (
        <>
            <Box className={clsx(classes.container, commonClasses.flexColumn)}>
                <Box className={classes.nameRow}>
                    <Typography className={clsx(classes.typo, commonClasses.typo16_600)}>
                        {`${props.data.firstName} ${props.data.lastName}`}
                    </Typography>
                    {clientOwes && <span className={classes.owesPill}>Owes</span>}
                </Box>
                <Box className={clsx(classes.info, commonClasses.flexRow)}>
                    <FontAwesomeIcon
                        icon={faPhoneFlip}
                        className={clsx(classes.icon)}
                    />
                    <Typography className={clsx(classes.typo, commonClasses.typo15_400)}>{props.data.phone}</Typography>
                </Box>
                <Box className={clsx(classes.info, commonClasses.flexRow)}>
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        className={clsx(classes.icon)}
                    />
                    <Typography className={clsx(classes.typo, commonClasses.typo15_400)}>{props.data.email}</Typography>
                </Box>
                <Box className={classes.tagContent}>
                    {props.data.tags.positive.map(tag => (
                        <Chip
                            key={tag.id}
                            label={tag.name}
                            className={classes.clientTag}
                        />
                    ))}

                    {props.data.tags.negative.map(tag => (
                        <Chip
                            key={tag.id}
                            label={tag.name}
                            className={classes.clientTag}
                        />
                    ))}
                </Box>
            </Box>
        </>
    );
};

export default ClientInfo;
